module Meevo.Plugins.AlertsManager {

    import IAlertJSON = Meevo.Model.IAlertJSON;

    interface IItem {
        id: string;
        displayName: string;
    }

    interface ISingleMoverAlertJson extends IAlertJSON {
        [key: string]: any;
    }

    class MeevoAlertManagerSingleMoverConfigComponent extends BaseConfigComponent implements ng.IComponentController {

        static $inject = [
            'meevo.plugins.alertsManager.AlertsManagerService',
            '$translate'
        ];

        public params: IParams;
        public data: ISingleMoverData;

        public selectedItems: IItem[];
        public allSelected: boolean = false;

        get dataForReview() {
            return (this.allSelected && !this.data.useAllItemsAsSelected)
                ? [this.$translate.instant('LABEL_ALL')]
                : (this.selectedItems || []).map((item) => item.displayName);
        }

        get alertConfiguration() {
            if (!!this.data.allConfigKey) {
                return {
                    [this.data.configKey]: (this.selectedItems || []).map((item) => item.id),
                    [this.data.allConfigKey]: this.allSelected,
                };
            }

            return {
                [this.data.configKey]: (this.selectedItems || []).map((item) => item.id),
            };
        }

        constructor(protected alertsManagerService: IAlertsManagerService,
                    protected $translate: ng.translate.ITranslateService) {
            super(alertsManagerService);
        }

        onEdit(alertJSON: ISingleMoverAlertJson): void {
            this.selectedItems = alertJSON[this.data.configKey].map((itemId) => (<IItem>{id: itemId}));
            if (!!this.data.allConfigKey) {
                this.allSelected = alertJSON[this.data.allConfigKey];
            }
        }
    }

    angular.module('meevo.plugins.alertsManager')
        .component('meevoAlertManagerSingleMoverConfigComponent', <angular.IComponentOptions>{
            templateUrl: 'app/plugins/alertsManager/addNewAlert/config-components/single-mover-config/single-mover-config.component.html',
            controller: MeevoAlertManagerSingleMoverConfigComponent,
            controllerAs: '$ctrl',
            bindings: {
                params: '<',
                data: '<'
            }
        });
}